import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";

export default function MobilizationConfrimPopUp({
  PopUp,
  setYesPopup,
  callBack,
  title,
}) {
  const dispatch = useDispatch();

  const onSubmit = async () => {
    callBack();
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setYesPopup(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5 text-center">
              <div className="form-control w-full text-center gap-2">
                <span className="label-text  text-xl text-center">{title}</span>
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ margin: 2 }}
              >
                <button
                  type="submit"
                  className="p-3 bg-green-500 text-white rounded-md w-full max-w-48  my-4 flex  justify-center items-center text-sm"
                  onClick={() => {
                    // setLoading(true);
                    onSubmit();
                  }}
                >
                  <p>Proceed </p>
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
          </div>
          {/* <label>error</label> */}
        </div>
      </div>
    </>
  );
}
